import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cvOrdinalLocalize'
})
export class CvOrdinalLocalizePipe implements PipeTransform {

  transform(rawNumber: number): string {
    var s = rawNumber.toString();
    var newValue = "";

    // Negative and zero have no ordinal representation
    if (rawNumber < 1){
      newValue = s;
    }

    rawNumber %= 100;
    if ((rawNumber >= 11) && (rawNumber <= 13)){
      newValue = s + "th";
    }

    switch (rawNumber % 10) {
      case 1: 
        newValue = s + "st"; 
        break;
      case 2: 
        newValue = s + "nd";
        break;
      case 3: 
        newValue = s + "rd";
        break;
      default:
        newValue = s + "th";
        break;
    }

    return newValue;
  }
}